import React, { useRef, useState, useEffect } from "react";
import { Button, Checkbox, Flex, Slider } from "antd";
import { ReactComponent as FilterIcon } from "../../assets/Icons/filterIcon2.svg";
import { ReactComponent as DropdownIcon } from "../../assets/Icons/dropdown.svg";
import { ReactComponent as CloseIcon } from "../../assets/Icons/close.svg";
import { ReactComponent as ToggleArrow } from "../../assets/Icons/upArrowIcon.svg";
import "./TableFilter.scss";
import NormalButton from "../NormalButton/NormalButton";

const TableFilterDropdown = ({ sections = [], onApply }) => {
  const [open, setOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [expandedSections, setExpandedSections] = useState({});
  const ref = useRef();

  const toggleDropdown = () => setOpen((prev) => !prev);

  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const handleCheckboxChange = (sectionKey, value) => {
    setSelectedFilters((prev) => {
      const current = prev[sectionKey] || [];
      const updated = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];
      return { ...prev, [sectionKey]: updated };
    });
  };

  const handleRangeChange = (sectionKey, range) => {
    setSelectedFilters((prev) => ({
      ...prev,
      [sectionKey]: range,
    }));
  };

  const handleClearAll = () => {
    setSelectedFilters({});
  };

  const handleApply = () => {
    onApply?.(selectedFilters);
    setOpen(false);
  };

  const toggleSection = (key) => {
    setExpandedSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <div className="filter-button-wrapper" ref={ref}>
      <div className="filterTab">
        <Button onClick={toggleDropdown}>
          <FilterIcon />
          Filter <DropdownIcon />
        </Button>
      </div>

      {open && (
        <div className="filter-dropdown-panel">
          <Flex
            justify="space-between"
            align="center"
            className="filter-header"
          >
            <h3>Filter</h3>
            <CloseIcon onClick={toggleDropdown} style={{ cursor: "pointer" }} />
          </Flex>

          <div className="filter-body">
            {sections.map((section) => {
              const isExpanded = expandedSections[section.key] ?? true;

              return (
                <div key={section.key} className="filter-section">
                  <Flex
                    className="filter-section-header"
                    justify="space-between"
                    align="center"
                    onClick={() => toggleSection(section.key)}
                    style={{ cursor: "pointer" }}
                  >
                    <h4>{section.label}</h4>
                    <ToggleArrow
                      style={{
                        transform: isExpanded
                          ? "rotate(0deg)"
                          : "rotate(180deg)",
                        transition: "transform 0.3s ease",
                      }}
                    />
                  </Flex>

                  {isExpanded &&
                    (section.key === "disposition" ? (
                      <div className="range-slider-wrapper">
                        {/* <Slider
                          range
                          min={section.min || 0}
                          max={section.max || 100}
                          step={1}
                          value={selectedFilters[section.key] || [0, 100]}
                          onChange={(val) =>
                            handleRangeChange(section.key, val)
                          }
                          trackStyle={{ backgroundColor: "#FF7143" }}
                          handleStyle={[
                            {
                              backgroundColor: "#ffffff",
                              border: "4px solid #FF7143",
                            },
                            {
                              backgroundColor: "#ffffff",
                              border: "4px solid #FF7143",
                            },
                          ]}
                          tooltip={{ open: false }}
                          railStyle={{ backgroundColor: "#E5E5E5" }}
                        /> */}
                        <Slider
                          range
                          min={0}
                          max={100}
                          step={1}
                          value={
                            selectedFilters[section.key] || [
                              section.min || 0,
                              section.max || 100,
                            ]
                          }
                          onChange={(val) => {
                            // Clamp values inside [section.min, section.max]
                            const clamped = [
                              Math.max(section.min ?? 0, val[0]),
                              Math.min(section.max ?? 100, val[1]),
                            ];
                            handleRangeChange(section.key, clamped);
                          }}
                          trackStyle={{ backgroundColor: "#FF7143" }}
                          handleStyle={[
                            {
                              backgroundColor: "#ffffff",
                              border: "4px solid #FF7143",
                            },
                            {
                              backgroundColor: "#ffffff",
                              border: "4px solid #FF7143",
                            },
                          ]}
                          railStyle={{ backgroundColor: "#E5E5E5" }}
                          tooltip={{ open: false }}
                        />

                        {/* <Flex
                          justify="space-between"
                          style={{ fontSize: 13, fontWeight: 500 }}
                        >
                          <span>
                            {(selectedFilters[section.key] || [0])[0]}%
                          </span>
                          <span>
                            {(selectedFilters[section.key] || [100])[1]}%
                          </span>
                        </Flex> */}
                        {/* <div className="value-labels">
                          <span>
                            {
                              (selectedFilters[section.key] || [
                                section.min || 0,
                              ])[0]
                            }
                            %
                          </span>
                          <span>
                            {
                              (selectedFilters[section.key] || [
                                section.max || 100,
                              ])[1]
                            }
                            %
                          </span>
                        </div> */}
                        <div className="value-labels">
                          <span>
                            {selectedFilters[section.key]?.[0] ?? section.min}%
                          </span>
                          <span>
                            {selectedFilters[section.key]?.[1] ?? section.max}%
                          </span>
                        </div>
                      </div>
                    ) : (
                      //   <div className="checkbox-grid">
                      <div
                        className={
                          section.options.length < 4
                            ? "checkbox-main"
                            : "checkbox-grid"
                        }
                      >
                        {section.options.map((opt) => (
                          <Checkbox
                            key={opt.value}
                            checked={selectedFilters[section.key]?.includes(
                              opt.value
                            )}
                            onChange={() =>
                              handleCheckboxChange(section.key, opt.value)
                            }
                          >
                            {opt.label}
                          </Checkbox>
                        ))}
                      </div>
                    ))}
                </div>
              );
            })}
          </div>

          <Flex justify="space-between" className="filter-footer">
            <Button type="text" className="clear-btn" onClick={handleClearAll}>
              Clear all
            </Button>
            <NormalButton
              text="Apply"
              controlHeight={35}
              onClick={handleApply}
            />
          </Flex>
        </div>
      )}
    </div>
  );
};

export default TableFilterDropdown;
